import axios from "@/services/axios.config";
import { PublicProjectType } from "@/types/publicProject";
import { toastOnError } from "@/utils/toastOnError";
import { useQuery } from "@tanstack/react-query";

export type ProjectWithPagination = {
	limit: string;
	offset: string;
	count: string;
	projects: PublicProjectType[];
};

const getValidatedPublicProjects = async (limit: number, offset: number, status: string[], sectoralScopeId?: string) =>
	axios
		.get<APIResponse<ProjectWithPagination>>("project/public/list?", {
			params: { limit, offset, status, sectoralScopeId },
		})
		.then((res) => res.data.data)
		.catch((err) => Promise.reject(err.response.data as APIResponse));

export default function useGetValidatedPublicProjects(
	limit: number,
	offset: number,
	status: string[],
	sectoralScopeId?: string,
) {
	return useQuery({
		queryKey: ["validatedPublicProjects", limit, offset, status, sectoralScopeId],
		queryFn: () => getValidatedPublicProjects(limit, offset, status, sectoralScopeId),
		onError: (err: APIResponse) => {
			toastOnError(err);
		},
	});
}
